import './Item.css'
import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { getThemeColor } from 'utils/utils'
import { COURSE_PATH } from 'routes/path'
import NETImage from 'components/net-image'
import IconFont from 'components/iconfont/IconFont'

/**
 * 课程项
 */
export default memo(function CourseItem({ item, theme }) {
    const history = useHistory()
    const themeColor = getThemeColor(theme)

    const onSelect = () => {
        history.push(COURSE_PATH(theme, item.id))
    }

    return (
        <div className='course-item' onClick={onSelect}>
            <NETImage
                prefix={theme}
                src={item.cover}
                className='course-item_cover'
            />
            <div className='course-item_right'>
                <div className={`course-item_title-control ${item.intro ? '' : ' hide-intro'}`}>
                    <span className='course-item_title' style={{ color: themeColor.default }}>{item.title}</span>
                    <IconFont name='play' color={themeColor.light} size={20} />
                </div>
                <div className='course-item_intro'>{item.intro}</div>
            </div>
        </div>
    )
})